import axios from "axios"

// 创建 axios 实例
axios.defaults.baseURL = import.meta.env.VITE_BASE_URL;
axios.defaults.timeout = 60000;
